


















































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'
import { formatJson, resetObjValue2NoneString } from '@/utils/tool'
import { getSEOList, addEditSEO, deleteSEO, setDefaultSEO } from '@/api/content/content-seo/index'
import Sortable from 'sortablejs'
import { exportJson2Excel } from '@/utils/excel'

@Component({
  name: 'NewsList'
})
export default class extends mixins(DateOption) {
  params = {
    ids: '',
    webpageName: ''
    // page: 1,
    // pageCount: 20
  }
  formParams: any = {
    id: 0,
    webpageName: '',
    title: '',
    titleOption: 0,
    descripOption: 0,
    description: '',
    descriptionOption: 0,
    keywords: '',
    keywordsOption: 0,
    isDefault: 0
  }
  tableLoading = false
  tableData: any[] = []
  selectedData: any[] = []
  classifyList: any[] = []
  dateArray: string[] = ['', '']
  totalCount = 0
  showEdit: boolean = false
  openWindow: any
  tableHeight: number = 500
  operate: string = ''
  tagList: any[] = []
  isIndeterminate: boolean = false
  checkAll: boolean = false
  checkedTags: number[] = []
  type: string = 'all'
  activeIndex: number = 0
  tabs: any[] = [{
    text: '全部',
    value: 0
  }, {
    text: '资讯',
    value: 1
  }, {
    text: '教程',
    value: 2
  }]

  created() {
    this.getTableData()
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
  }
  mounted() {
    this.rowDrop()
  }
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight)
  }

  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 200 - filterDom.clientHeight
  }

  async getTableData() {
    this.tableLoading = true
    let res = await getSEOList(this.params)
    this.tableData = res.data.dataList || []
    console.log(this.tableData)
    this.tableLoading = false
  }

  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.getTableData()
  }

  async confirmAddForm() {
    console.log(this.formParams)
    if (this.formParams.webpageName.length <= 0) return this.$message.warning('请输入页面名称')
    if (this.formParams.title.length <= 0) return this.$message.warning('请输入页面标题')
    if (this.formParams.description.length <= 0) return this.$message.warning('请输入页面描述')
    if (this.formParams.keywords.length <= 0) return this.$message.warning('请输入页面关键词')
    let res = await addEditSEO(this.formParams)
    this.showEdit = false
    this.getTableData()
  }

  cancelAddForm() {
    this.showEdit = false
  }

  handleReset() {
    this.params = {
      ids: '',
      webpageName: ''
    }
    this.getTableData()
  }
  handleAdd(row: any) {
    if (row) {
      for (let key in this.formParams) {
        this.formParams[key] = row[key]
      }
    } else {
      this.formParams = {
        id: 0,
        webpageName: '',
        title: '',
        titleOption: 0,
        descripOption: 0,
        description: '',
        descriptionOption: 0,
        keywords: '',
        keywordsOption: 0,
        isDefault: 0
      }
    }
    this.showEdit = true
  }
  handleEdit({ id }: any) {
    this.openWindow({
      name: 'NewsEdit',
      query: { id }
    })
  }
  handleDelete(ids: number[]) {
    this.$confirm('确认操作吗?', '', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
      iconClass: 'far fa-question-circle color-primary',
      customClass: 'tutu-dialog'
    })
      .then(() => {
        deleteSEO({ ids: ids.toString() }).then((res: any) => {
          if (res.status.code === 0) {
            this['$message'].success('删除成功')
            this.getTableData()
          } else {
            this['$message'].error('删除失败')
          }
        })
      })
      .catch(() => {})
  }
  handleSelectionChange(list: any[]) {
    this.selectedData = list
  }
  handleChange(val: string) {
    if (val === 'delete') {
      this.handleDelete(this.selectIds)
    }
  }
  handleSelectAll() {
    // 如果没有选择全部, 则寻找未选择的行, 并将这些行选中
    if (this.selectedData.length < this.tableData.length) {
      let tempSelectList = this.selectedData.map(item => item.id)
      let unSelected: any[] = this.tableData.filter((item: any) => !tempSelectList.includes(item.id))
      unSelected.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.id)
    tempSelectList = this.selectedData.map(item => item.id)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.id)) this.selectedData.push(item)
    })
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleCheckAllChange(val: boolean) {
    const ids :number[] = this.tagList.map((tag: any) => tag.id)
    this.checkedTags = val ? ids : []
    this.isIndeterminate = false
  }
  handleCheckedCitiesChange(value: number[]) {
    let checkedCount = value.length
    this.checkAll = checkedCount === this.tagList.length
    this.isIndeterminate = checkedCount > 0 && checkedCount < this.tagList.length
  }
  rowDrop() {
    const table = document.querySelector('.el-table__body-wrapper tbody')
    const _this = this
    // table 有值时才能对其进行操作
    if (table) {
      Sortable.create(table, {
        handle: '.bars',
        onEnd({ oldIndex, newIndex }: any) {
          if (oldIndex !== newIndex) {
            console.log(oldIndex, newIndex)
          }
        }
      })
    }
  }
  handleExcel() {
    const filterVal: string[] = [
      'id',
      'title',
      'category',
      'platform',
      'viewCount',
      'status',
      'editor',
      'publishDate'
    ]
    const theader: string[] = [
      'ID',
      '标题',
      '分类',
      '平台',
      '浏览量',
      '状态',
      '操作人',
      '发布时间'
    ]
    if (this.selectedData.length <= 0) {
      return this.$message.warning('请选择数据')
    }
    const list = this.selectedData
    const data = formatJson(filterVal, list)
    exportJson2Excel(theader, data)
    this['$message'].success('导出成功!')
    ;(this.$refs['multiTable'] as any).clearSelection()
  }

  // computed
  get showMultiSelect() {
    return this.selectedData.length > 1
  }
  get selectCount() {
    return this.selectedData.length
  }
  get selectIds() {
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    return t
  }
}
